'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import React from 'react';
import { useLlm } from '../../../useLlm/useLlm';

export type ThreadProps = {
};

export const Thread: React.FC<ThreadProps> = () => {
  const {
    ChunkWrapper,
    Disclaimer,
    Feedback,
    Stream,
  } = useLlm(state => state.components);
  const label = useLabel();
  const enableFeedback = useLlm(state => state.app?.contents.enableFeedback);
  const messages = useLlm(state => state.messages);
  const hasChunks = useLlm(state => state.chunks !== undefined);
  return (
    <section className="llm__thread llm__container">
      {messages.map((message, m) => (
        <div
          key={`llm-message-${message.messageId}-${m}`}
          className={getClassNames('llm__message', `llm__message--${message.role}`)}
          role="region"
          aria-label={message.role === 'user' ? label('llm.question') : label('llm.answer')}>
          {message.chunks.map((chunk, c) => (
            <ChunkWrapper
              key={`llm-message-${message.messageId}-chunk-${c}`}
              className={`llm__inner llm__inner--${chunk.type}`}
              item={chunk} chunkIndex={c} index={m} total={messages.length} role={message.role}
            />
          ))}
          {message.role === 'user' ? (
            m === 0 && <Disclaimer />
          ) : (
            m === messages.length - 1 && enableFeedback && <Feedback message={message} />
          )}
        </div>
      ))}
      {hasChunks && (
        <Stream index={messages.length} />
      )}
    </section>
  );
};
